import React, { Component } from 'react';

export class BecomeAWasher extends Component {
    render() {
        return (
            <h1>Become a washer</h1>
        );
    }
}